export default __webpack_public_path__ + "static/logo_black-12c146de5b402447bed0baed1fe3ac32.png";